import { render, staticRenderFns } from "./AddPromotion.vue?vue&type=template&id=535957cb&"
import script from "./AddPromotion.vue?vue&type=script&lang=js&"
export * from "./AddPromotion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports